import { render, staticRenderFns } from "./ApplicationConfirmation.vue?vue&type=template&id=56632bdc&lang=true&"
import script from "./ApplicationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ApplicationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports